var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.$store.getters.showContent)?_c('div',{staticClass:"container d-flex flex-column justify-content-start mt-5"},[_c('UpdateComponent')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }